import type { OnboardingVariant } from '@scio3/shared-types';

const STORAGE_KEY = 'scio3b-split-override';

function isVariant(value: string | null): value is OnboardingVariant {
  return value === 'scio3a' || value === 'scio3b' || value === 'scio3c';
}

/**
 * QA-only escape hatch — lets internal testers force a specific variant via
 * `?force_variant=scio3a` / `?force_variant=scio3b` / `?force_variant=scio3c`.
 * Persisted to sessionStorage so subsequent navigations stay on the forced
 * variant for the session.
 *
 * **Honored only in non-production environments** (sandbox / qa / local) so the
 * override can't leak into prod experiment metrics. Logs a console warning when
 * applied so its presence in DevTools is obvious.
 */
export function readQaOverride(): OnboardingVariant | null {
  if (typeof window === 'undefined') return null;
  if (import.meta.env.VITE_POSTHOG_ENVIRONMENT === 'production') return null;

  const url = new URL(window.location.href);
  const param = url.searchParams.get('force_variant');
  if (isVariant(param)) {
    sessionStorage.setItem(STORAGE_KEY, param);
    console.warn(`[experiment] scio3b-split QA override: forcing variant=${param}`);
    return param;
  }

  const stored = sessionStorage.getItem(STORAGE_KEY);
  if (isVariant(stored)) return stored;
  return null;
}
